<template>
  <div>
    <a-upload-dragger
        name="file"
        :multiple="true"
        :action="uploadUrl"
        @change="handleFileUpload"
        :showUploadList="false"
        :disabled="disabled"
        v-if="!disabled"
        :data="{detailId : detailId, path : path}"
    >
      <p class="ant-upload-drag-icon">
        <inbox-outlined></inbox-outlined>
      </p>
      <p class="ant-upload-text">
        {{$t("uploadTip")}}
      </p>
    </a-upload-dragger>
    <div style="width: 100%">
      <a-alert
          v-for="file in fileList"
          :key="file.id"
          :message="file.realname"
          type="success"
          :showIcon="true"
          :closable="!disabled"
          @click="downLoad(file.id, file.realname)"
          @close="deleteFile(file.id)"
          style="margin-top: 10px;cursor: pointer"
      >
      </a-alert>
    </div>
    <v-loading :show="loading"></v-loading>
  </div>
</template>

<script>
import util from "@/util/util";
import VLoading from "@/components/public/v-loading";
import { InboxOutlined } from '@ant-design/icons-vue';

export default {
  name: "cibrFileUpload",
  components: {VLoading, InboxOutlined},
  props : {
    detailId : String,
    path : String,
    disabled : Boolean
  },
  data :function (){
    return {
      fileList : [],
      fileIdList : [],
      loading : false,
    }
  },
  beforeMount() {
    this.initPage();
  },
  methods : {
    initPage(){
      var that = this;
      this.fileList = [];
      this.fileIdList = [];
      this.$axios.post("/file/initFileList", {detailId : this.detailId}).then(function (res){
        if (res.data.code === util.SUCCESS){
          that.fileList = res.data.retMap.fileList;
        }else {
          util.error(res.data.code);
        }
      }).catch(function (res){
        util.catchErr(res);
      })
    },
    handleFileUpload : function (evn){
      if (evn.file.status === "uploading"){
        this.loading = true;
      }else {
        this.loading = false;
      }
      if (evn.file.status === "done"){
        this.fileList = [...this.fileList, evn.file.response.retMap.file];
        this.fileIdList = [...this.fileIdList, evn.file.response.retMap.file.id];
        var parms = {
          fileList : this.fileList,
          fileIdList : this.fileIdList
        }
        this.$emit("fileChange", parms)
        util.uploadSuccess();
      }
    },
    downLoad : function (fileId, fileName){
      console.log(fileId, fileName)
      util.commonDownload(fileId, fileName);
    },
    deleteFile : function (fileId){
      event.stopPropagation()
      var post = {
        fileId : fileId
      }
      var that = this;
      this.$axios.post("/file/delete",post).then(function (res){
        if (res.data.code === util.SUCCESS){
          util.success(that.$t("deleteSuccess"));
          let files = that.fileList.filter(item => item.id !== fileId);
          that.fileList = files;
          let fileIds = that.fileIdList.filter(item => item !== fileId);
          that.fileIdList = fileIds;
          var parms = {
            fileList : that.fileList,
            fileIdList : that.fileIdList
          }
          that.$emit("change", parms)
        }else {
          util.error(res.data.code);
        }
      }).catch(function (res){
        util.catchErr(res);
      });
    },
  },
  watch : {
    detailId(){
      this.initPage();
    }
  },
  computed : {
    uploadUrl : function (){
      return util.getCommonUploadUrl();
    },
  }
}
</script>

<style scoped>

</style>